import React from 'react';
import Page from './Page';

import './SportsPage.css';

export class SportsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hover1: 1,
			hover2: 0
		};
	}

	render() {
		const {hover1, hover2} = this.state;

		return (
			<Page className="SportsPage fullwidth" title="B2Me for Sports">
				<div className="headerImg">
					<p>
						Working together, <br />
						<strong>on and off the court</strong>
					</p>
					<img className="damianHeader" src="/img/damian1.png" alt="damian" />
				</div>

				<div className="displayBoxes">
					<div
						className={`box ${hover1 === 0 && 'highlight'}`}
						onMouseEnter={() => this.setState(prevState => ({...prevState, hover1: 0}))}>
						<h1>Network</h1>
						<p>
							Create mutually-beneficial partnerships with local businesses who are part of your
							sporting community
						</p>
					</div>
					<div
						className={`box ${hover1 === 1 && 'highlight'}`}
						onMouseEnter={() => this.setState(prevState => ({...prevState, hover1: 1}))}>
						<h1>Connect</h1>
						<p>Make it easier for your club members to support businesses of other club members</p>
					</div>
					<div
						className={`box ${hover1 === 2 && 'highlight'}`}
						onMouseEnter={() => this.setState(prevState => ({...prevState, hover1: 2}))}>
						<h1>Promote</h1>
						<p>
							Add value to your sponsors by connecting them with small family businesses within your
							club
						</p>
					</div>
				</div>
				<section>
					<h1>About B2Me for Sports</h1>

					<div className="imageSection">
						<div className="displayImg" />
						<div className="content highlight">
							<p>
								All team sports rely on people working together and supporting each other for the
								good of the game. This is as true off the court as it is on the court. By supporting
								the small, family businesses within the club, it builds community connection and
								strengthens team spirit. Thats where B2Me for Sports comes in.
							</p>
							<p>
								Our directory makes it easier for you to support the local businesses within your
								club. It is purposely designed to highlight your sponsors and support your members,
								players, affiliations and business partners. By giving your business to others you
								will get business in return. This extends to employment opportunities for current
								players, career advice and introductions which are becoming increasingly more
								important in our society today.
							</p>
						</div>
					</div>
				</section>

				<section>
					<h1>Put your members first</h1>
					<div className="memberBoxes">
						<div
							className={`box ${hover2 === 0 && 'highlight'}`}
							onMouseEnter={() => this.setState(prevState => ({...prevState, hover2: 0}))}>
							<p>
								Build a pipeline of interest that can increase club revenue and thus club resources
							</p>
						</div>
						<div
							className={`box ${hover2 === 1 && 'highlight'}`}
							onMouseEnter={() => this.setState(prevState => ({...prevState, hover2: 1}))}>
							<p>Generate introductions for players to help with career opportunities</p>
						</div>
						<div
							className={`box ${hover2 === 2 && 'highlight'}`}
							onMouseEnter={() => this.setState(prevState => ({...prevState, hover2: 2}))}>
							<p>Network with sponsors and business owners who can provide benefits to members</p>
						</div>
						<div
							className={`box ${hover2 === 3 && 'highlight'}`}
							onMouseEnter={() => this.setState(prevState => ({...prevState, hover2: 3}))}>
							<p>Update businesses and players through the noticeboard features</p>
						</div>
					</div>
				</section>

				{/* <section>
					<h1>Our gallery</h1>
					<img className="gallery" src="/img/sports-gallery.png" />
				</section> */}

				<div className="testomonialSect">
					<h1>Testimonial</h1>
					<div className="testomonial highlight">
						<div className="header">
							<div>
								<img className="headshot" src="/img/damian-headshot.png" alt="Damian Martin" />
								<span>Damian Martin</span>
							</div>
							<img className="quote" src="/img/quote.png" alt="quote" />
						</div>
						<blockquote>
							" I know that my performance as a professional basketball player can certainly be
							attributed to the fantastic people that supported me throughout my journey. Being able
							to rely on a network of health professionals, sponsors, and fans made it all the
							easier to give my all to each game. Now, as I develop my career in real estate, the
							lessons I learnt as a professional sportsperson are serving me well. Being able to
							create a network of like-minded people, who help me as I help them really makes all
							the difference. Being able to use B2Me to see that a network of support, and expand it
							through community connectedness, is brilliant! I encourage any club leader to make the
							most of the opportunity it presents. "
						</blockquote>
					</div>
				</div>

				{/* <section>
				<h1>See how clubs are working with us</h1>
				<ul className="row">
					<li className="CommunityCard">
						<div
							style={{
								backgroundImage: 'url("/api/image/84a75b8c-46f3-472f-baae-285de53bffe2")',
								backgroundPosition: 'center'
							}}>
							<h2 key="name" className="long">
								Perth football club
							</h2>
							<div key="location" className="CommunityCard-location">
								<span className="icon icon-room" />
								&nbsp;
								<span>Perth</span>
							</div>
							<div key="member" className="CommunityCard-member-count">
								<span className="icon icon-people" />
								&nbsp;
								<span>48</span>
							</div>
						</div>
					</li>
					<li className="CommunityCard">
						<div
							style={{
								backgroundImage: 'url("/api/image/01c2fd78-9f91-4ea2-854d-38c55e0b9036")',
								backgroundPosition: 'center'
							}}>
							<h2 key="name" className="long">
								Perth basketball club
							</h2>
							<div key="location" className="CommunityCard-location">
								<span className="icon icon-room" />
								&nbsp;
								<span>Perth</span>
							</div>
							<div key="member" className="CommunityCard-member-count">
								<span className="icon icon-people" />
								&nbsp;
								<span>39</span>
							</div>
						</div>
					</li>
				</ul>
			</section> */}

				<section>
					<a
						className="callToAction"
						target="_blank"
						rel="noopener noreferrer"
						href="https://share.hsforms.com/1IpKFZ73dRjyHzG9ZGQkoPw2gqzs">
						<p className="secondary">Find out how to get started with B2Me for Sports</p>
						<p className="primary">Get in touch</p>
					</a>
				</section>

				<img className="sportsImg" src="/img/sports2.png" alt="" />
			</Page>
		);
	}
}

export default SportsPage;



// WEBPACK FOOTER //
// ./src/pages/SportsPage.js